import type { FC, ReactNode } from 'react'

import { usePlayer } from '@/components/player/player-provider'

/** Keeps the footer clear of the mini player once something is in the queue. */
export const PlayerSpacer: FC = (): ReactNode => {
    const { current } = usePlayer()

    if (!current) return null

    return <div className='h-[76px] shrink-0 bg-obsidian' aria-hidden='true' />
}
